import { useState, useEffect, useCallback } from "react";


function TipCalculator() {
  const [bill, setBill] = useState("");
  const [tipPercent, setTipPercent] = useState(15);
  const [noOfPeople, setNoOfPeople] = useState(1);
  const [totalTip, setTotalTip] = useState(0);
  const [total, setTotal] = useState(0);
  const [tipPerPerson, setTipPerPerson] = useState(0);
  const [totalPerPerson, setTotalPerPerson] = useState(0);

  

  const calculateTip = useCallback(() => {
    let billAmount = parseFloat(bill);
    let tipPercentage = parseFloat(tipPercent);
    let people = parseInt(noOfPeople);

    let totalTipAmount = parseFloat(
      (billAmount * (tipPercentage / 100)).toFixed(2)
    );
    let totalAmount = parseFloat((billAmount + totalTipAmount).toFixed(2));
    let tipPerPersonAmount = parseFloat((totalTipAmount / people).toFixed(2));
    let totalPerPersonAmount = parseFloat((totalAmount / people).toFixed(2));

    setTotalTip(totalTipAmount);
    setTotal(totalAmount);
    setTipPerPerson(tipPerPersonAmount);
    setTotalPerPerson(totalPerPersonAmount);
  }, [bill, tipPercent, noOfPeople])

  useEffect(() => {
    calculateTip();
  }, [calculateTip]);

  return (
    <div className="bg-white w-full sm:w-[450px] py-10 px-[30px] rounded-lg drop-shadow-2xl mx-auto h-fit sm:h-[550px]">
      <section className="mb-8">
        <div className="wrapper flex items-center justify-between my-3">
          <label
            htmlFor="bill"
            className="lbl text-sm font-medium text-gray-700"
          >
            Bill
          </label>
          <div className="input-box bg-blue-100 text-blue-700 px-2 py-1">
            <span>$</span>
            <input
              type="number"
              value={bill}
              placeholder="0.00"
              id="bill"
              className="val text-sm font-semibold bg-blue-100 border-none outline-none w-24 text-right text-blue-700"
              onChange={(e) => setBill(e.target.value)}
            />
          </div>
        </div>
        <div className="wrapper flex items-center justify-between my-3">
          <span className="lbl text-sm font-medium text-gray-700">Tip</span>
          <span
            id="tip-amount"
            className="val text-sm font-semibold text-gray-700"
          >
            ${totalTip?totalTip.toFixed(2):"0"}
          </span>
        </div>
        <div className="bg-gray-200 my-[30px] h-[1px] w-full"></div>
        <div className="wrapper flex items-center justify-between my-3">
          <span className="lbl text-sm font-medium text-gray-700">
            Total Amount
          </span>
          <span
            id="total-amount"
            className="val text-sm font-semibold text-gray-700"
          >
            ${total?total.toFixed(2):"0"}
          </span>
        </div>
      </section>
      <section className="mb-8 mt-8">
        <div className="wrapper flex items-center justify-between my-3">
          <label
            htmlFor="tip"
            className="lbl text-sm font-medium text-gray-700"
          >
            Tip %
          </label>
          <span
            id="tip-percent"
            className="val text-sm font-semibold text-gray-700"
          >
            {tipPercent}
          </span>
        </div>
        <input
          type="range"
          min="1"
          id="tip"
          value={tipPercent}
          className="w-full my-2 h-1 cursor-pointer bg-gray-200 rounded-lg appearance-none range-sm"
          onChange={(e) => {
            setTipPercent(e.target.value);
          }}
        />
        <div className="wrapper flex items-center justify-between my-3">
          <label
            htmlFor="no-of-people"
            className="lbl text-sm font-medium text-gray-700"
          >
            No. Of People
          </label>
          <span
            id="split-num"
            className="val text-sm font-semibold text-gray-700"
          >
            {noOfPeople}
          </span>
        </div>
        <input
          type="range"
          min="1"
          max="15"
          id="no-of-people"
          value={noOfPeople}
          className="w-full h-1 cursor-pointer my-2 bg-gray-200 rounded-lg appearance-none range-sm"
          onChange={(e) => {
            setNoOfPeople(e.target.value);
          }}
        />
      </section>
      <section className="mt-8 bg-blue-100 rounded-md p-[10px] text-blue-700">
        <div className="wrapper flex items-center justify-between my-3">
          <span className="lbl text-sm font-medium"> Tip Per Person </span>
          <span id="tip-per-person" className="val text-sm font-semibold">
            ${tipPerPerson?tipPerPerson.toFixed(2):"0"}
          </span>
        </div>
        <div className="wrapper flex items-center justify-between my-3">
          <span className="lbl text-sm font-medium"> Total Per Person </span>
          <span id="total-per-person" className="val text-sm font-semibold">
            ${totalPerPerson?totalPerPerson.toFixed(2):"0"}
          </span>
        </div>
      </section>
    </div>
  );
}

export default TipCalculator;